import * as am5 from '@amcharts/amcharts5';

class DynamicTheme extends am5.Theme {
    setupDefaultRules() {
        this.rule("Label").setAll({
            fontSize: 12,
            fill: am5.color(0x777777)
        });
        this.rule("ColorSet").setAll({
            colors: [
                // am5.color(getComputedStyle(document.documentElement).getPropertyValue('--chart-bg').trim()), // background
                // am5.color(getComputedStyle(document.documentElement).getPropertyValue('--chart-text').trim()), // text
                am5.color(getComputedStyle(document.documentElement).getPropertyValue('--chart-1').trim()), // primary fill
                am5.color(getComputedStyle(document.documentElement).getPropertyValue('--chart-2').trim()), // secondary fill
                am5.color(getComputedStyle(document.documentElement).getPropertyValue('--chart-3').trim()), // primary fill
                am5.color(getComputedStyle(document.documentElement).getPropertyValue('--chart-4').trim()), // secondary fill
                am5.color(getComputedStyle(document.documentElement).getPropertyValue('--chart-5').trim()), // primary fill
                am5.color(getComputedStyle(document.documentElement).getPropertyValue('--chart-6').trim())  // secondary fill

            ],
            reuse: true
        });
    }
}

export default DynamicTheme;